import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-resource-sub-tpye-formatter-renderer',
  template: `
    {{params?.value }}
  `
})
export class ResourceSubTypeFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;
  IconCheck = IoniconsOutline.check;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}

